import { render, staticRenderFns } from "./ProjectCardsPagination.vue?vue&type=template&id=007a69b7"
import script from "./project-cards-pagination.ts?vue&type=script&lang=ts&external"
export * from "./project-cards-pagination.ts?vue&type=script&lang=ts&external"
import style0 from "./project-cards-pagination.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports